/*global chai, controllers, describe, it, after*/
var expect = chai.expect;


describe('Login', function() {
    it('should display login', function(done) {
      if(controllers.login.view.EL.connect){
        return done() ;
      }
      controllers.login.view.once('displayed', function(){done() ;}) ;
    }) ;
    it('should display error when nothing is inputed', function() {
      controllers.login.view.EL.connect.click() ;
      expect(document.querySelector(".alert.alert-danger")).to.exist ;
    });
    it('should display error when miss password', function() {
      controllers.login.view.EL.connectLogin.value = "alogin" ;
      controllers.login.view.EL.connect.click() ;
      expect(document.querySelector(".alert.alert-danger")).to.exist ;
    });
    it('should display error when miss login', function() {
      controllers.login.view.EL.connectLogin.value = "" ;
      controllers.login.view.EL.connectPassword.value = "" ;
      controllers.login.view.EL.connect.click() ;
      expect(document.querySelector(".alert.alert-danger")).to.exist ;
    });
    it('should display error when send wrong login/pass', function() {
      controllers.login.view.EL.connectLogin.value = "wronglogin" ;
      controllers.login.view.EL.connectPassword.value = "wrongpass" ;
      controllers.login.view.EL.connect.click() ;
      expect(document.querySelector(".alert.alert-danger")).to.exist ;
    });
    it('should close login when send good login/pass', function(done) {
      controllers.login.view.once("close", function(){done() ;}) ;
      controllers.login.view.EL.connectLogin.value = "admin" ;
      controllers.login.view.EL.connectPassword.value = "admin" ;
      controllers.login.view.EL.connect.click() ;
    });
    it('should go back to login on logout', function(done) {
      controllers.welcome.view.once("displayed", function(){
        //wait welcome view is displayed
        controllers.login.view.once("displayed", function(){
          //test is ok when login view came
          done() ;
        }) ;
        //emit the logout
        controllers.main.view.emit("logout") ;
      }) ;
    });

    // after(function(done){
    //   controllers.login.api.logout(done) ;
    // }) ;
});